import fetch from 'isomorphic-fetch';
import { openModal } from './modalActions';

export const ActionTypes = {
  FILE_UPLOADING: 'zola/cards/file/FILE_UPLOADING',
  FILE_UPLOADED: 'zola/cards/file/FILE_UPLOADED',
  FILE_TEMP_UPLOADED: 'zola/cards/file/FILE_TEMP_UPLOADED',
  FILE_CROPPED: 'zola/cards/file/FILE_CROPPED',
  STORE_REFERENCE_KEY: 'zola/cards/file/STORE_REFERENCE_KEY',
  SHOW_REJECTION_PHOTO_MODAL: 'zola/cards/file/SHOW_REJECTION_PHOTO_MODAL',
  UPLOAD_INTERRUPTED: 'zola/cards/file/UPLOAD_INTERRUPTED',
  IS_BUSY: 'zola/cards/modal/IS_BUSY', // this should not be here, kept to maintain compatability with handleFailedSubmit action below
};

const uploading = imgKey => ({
  type: ActionTypes.FILE_UPLOADING,
  payload: imgKey,
});

const uploaded = (data, imgKey, isTempUpload) => {
  const fileData = {};
  fileData[imgKey] = data;
  fileData[imgKey].busy = false;
  const type = isTempUpload ? ActionTypes.FILE_TEMP_UPLOADED : ActionTypes.FILE_UPLOADED;
  return {
    type,
    payload: fileData,
  };
};

const interrupted = imgKey => {
  const fileData = {};
  fileData[imgKey] = {};
  fileData[imgKey].busy = false;
  return {
    type: ActionTypes.UPLOAD_INTERRUPTED,
    payload: fileData,
  };
};

const checkImage = path =>
  new Promise(resolve => {
    const img = new Image();
    img.onload = () => resolve({ path, status: 'ok', width: img.width, height: img.height });
    img.onerror = () => resolve({ path, status: 'error' });
    img.src = path;
  });

const fileCropped = (data, imgKey, contentKey) => {
  const fileData = {};
  fileData[imgKey] = data;
  fileData[imgKey].busy = false;
  fileData[imgKey].content_key = contentKey;
  return {
    type: ActionTypes.FILE_CROPPED,
    payload: fileData,
  };
};

export const handleFailedSubmit = referenceKey => dispatch => {
  dispatch({
    type: ActionTypes.STORE_REFERENCE_KEY,
    payload: referenceKey,
  });
  dispatch({
    type: ActionTypes.IS_BUSY,
    payload: false,
  });
};

export const showRejectionPhotoModal = (w, h) => ({
  type: ActionTypes.SHOW_REJECTION_PHOTO_MODAL,
  w,
  h,
});

/**
 * [uploadPhoto description]
 * @param  {[type]}  file         [description]
 * @param  {[type]}  imgKey       [description]
 * @param  {Boolean} isTempUpload [false returns {cloudfrount_url, url, uuid}, true returns{s3_bucket, s3_key, url, content_type}]
 * @return {[type]}               [description]
 */

export const uploadPhoto = (file, imgKey, isTempUpload) => dispatch => {
  const endPoint = isTempUpload ? '/web-api/v1/image/temp-upload' : '/web-api/v1/image/upload';
  const formData = new FormData();
  formData.append('attachment', file.files[0], file.name);
  dispatch(uploading(imgKey));
  return fetch(endPoint, {
    credentials: 'same-origin',
    method: 'POST',
    body: formData,
  })
    .then(response => response.json())
    .then(json => dispatch(uploaded(json, imgKey, isTempUpload)));
};

export const inputBtnTempUpload = (file, imgKey, width = 1200, height = 1200) => dispatch => {
  const URL = window.URL || window.webkitURL;
  const path = URL.createObjectURL(file.files[0]);
  const formData = new FormData();
  formData.append('attachment', file.files[0], file.name);
  const fileBytes = file.files[0].size / 1024 / 1000;
  dispatch(uploading(imgKey));
  return checkImage(path).then(img => {
    const imgSize = Math.max(img.width, img.height);
    formData.append('size', imgSize);

    const magnitude = Math.sqrt(1440000 / (width * height));
    const minW = Math.ceil(parseInt((width * magnitude) / 10, 10) * 10);
    const minH = Math.ceil(parseInt((height * magnitude) / 10, 10) * 10);

    if (img.width < minW - 50 || img.height < minH - 50) {
      // subtract 50 to allow for a little room for error
      dispatch(interrupted(imgKey));
      dispatch(
        openModal(
          'REJECT_SMALL_PHOTO_MODAL',
          { w: img.width, h: img.height, minW, minH },
          { size: 'md' }
        )
      );
      return true;
    }
    if (fileBytes > 10) {
      dispatch(interrupted(imgKey));
      dispatch(openModal('REJECT_BIG_PHOTO_MODAL', { bytes: fileBytes }));
      return true;
    }
    return fetch('/web-api/v1/image/temp-upload', {
      credentials: 'same-origin',
      method: 'POST',
      body: formData,
    })
      .then(response => response.json())
      .then(json => dispatch(uploaded(json, imgKey, true)));
  });
};

export const saveCrop = (bucketName, s3key, crop, contentType, imgKey, contentKey) => dispatch => {
  dispatch(uploading(imgKey));
  const requestBody = JSON.stringify({ bucketName, s3key, crop, contentType });
  return fetch('/web-api/v1/image/crop-save', {
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-type': 'application/json',
    },
    body: requestBody,
  })
    .then(response => response.json())
    .then(json => dispatch(fileCropped(json.data, imgKey, contentKey)));
};



// WEBPACK FOOTER //
// ./src/cards/actions/fileActions.js